import React, { useState } from 'react'
import { validateForm, contactFormValidations } from '../helpers/validations'
import changeHandler from '../helpers/changeHandler'
import toast from 'react-hot-toast'
import { Input } from './Inputs'
import Textarea from './TextArea'
import apiClient from '../lib/apiClient'

const initialState = {
  firstName: '',
  lastName: '',
  company: '',
  email: '',
  phone: '',
  message: ''
}

export default function ContactUs() {
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState(initialState)
  const [formErrors, setFormErrors] = useState(initialState)

  const handlePost = async (event) => {
    event.preventDefault()

    const errors = validateForm(formData, contactFormValidations)
    setFormErrors(errors)

    if (Object.keys(errors).length === 0) {
      try {
        setLoading(true)
        await apiClient.post('/contact-request', { ...formData })
        setLoading(false)
        setFormData(initialState)
        setFormErrors({})
        toast.success('Thank you! We will be contacting you soon.')
      } catch (error) {
        setLoading(false)
        console.error(error)
        toast.error('Unable to submit form')
      }
    }
  }

  const handleChange = changeHandler(setFormData)

  return (
    <div id='contact-us' className='bg-white py-16 px-4 overflow-hidden sm:px-6 lg:px-8 lg:py-24'>
      <div className='relative max-w-xl mx-auto z-1'>
        <svg
          className='absolute left-full transform translate-x-1/2 z-1'
          width={404}
          height={404}
          fill='none'
          viewBox='0 0 404 404'
          aria-hidden='true'
        >
          <defs>
            <pattern
              id='85737c0e-0916-41d7-917f-596dc7edfa27'
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits='userSpaceOnUse'
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className='text-gray-200'
                fill='currentColor'
              />
            </pattern>
          </defs>
          <rect
            width={404}
            height={404}
            fill='url(#85737c0e-0916-41d7-917f-596dc7edfa27)'
          />
        </svg>
        <svg
          className='absolute right-full bottom-0 transform -translate-x-1/2'
          width={404}
          height={404}
          fill='none'
          viewBox='0 0 404 404'
          aria-hidden='true'
        >
          <defs>
            <pattern
              id='85737c0e-0916-41d7-917f-596dc7edfa27'
              x={0}
              y={0}
              width={20}
              height={20}
              patternUnits='userSpaceOnUse'
            >
              <rect
                x={0}
                y={0}
                width={4}
                height={4}
                className='text-gray-200'
                fill='currentColor'
              />
            </pattern>
          </defs>
          <rect
            width={404}
            height={404}
            fill='url(#85737c0e-0916-41d7-917f-596dc7edfa27)'
          />
        </svg>
        <div id='contact-us' className='text-center'>
          <h2 className='text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl'>
            Let&apos;s work together
          </h2>
          <p className='mt-4 text-lg leading-6 text-gray-500'>
            {/* Nullam risus blandit ac aliquam justo ipsum. Quam mauris volutpat massa dictumst amet. Sapien tortor lacus
            arcu. */}
          </p>
        </div>
        <div className='mt-12'>
          <form
            onSubmit={handlePost}
            className='grid grid-cols-1 sm:grid-cols-2 gap-y-6 sm:gap-x-8 prose'
          >
            <div className='sm:col-span-1'>
              <Input
                id='firstName'
                label='First name'
                value={formData.firstName}
                handleChange={handleChange}
                error={formErrors.firstName}
              />
            </div>
            <div className='sm:col-span-1'>
              <Input
                id='lastName'
                label='Last name'
                value={formData.lastName}
                handleChange={handleChange}
                error={formErrors.lastName}
              />
            </div>
            <div className='sm:col-span-2'>
              <Input
                id='company'
                label='Company'
                value={formData.company}
                handleChange={handleChange}
                error={formErrors.company}
              />
            </div>
            <div className='sm:col-span-2'>
              <Input
                id='email'
                label='Email'
                value={formData.email}
                handleChange={handleChange}
                error={formErrors.email}
              />
            </div>
            <div className='sm:col-span-2'>
              <Input
                id='phone'
                label='Phone number'
                value={formData.phone}
                handleChange={handleChange}
                error={formErrors.phone}
              />
            </div>
            <div className='sm:col-span-2'>
              <Textarea
                id='message'
                label='Message'
                rows={4}
                value={formData.message}
                handleChange={handleChange}
                error={formErrors.message}
              />
            </div>
            <div className='sm:col-span-2'>
              <button
                disabled={loading}
                type='submit'
                className='w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500'
              >
                <div className='flex-1'>
                  {loading && <svg
                    aria-hidden='true'
                    role='status'
                    className='inline w-6 h-6 me-3 text-white animate-spin'
                    viewBox='0 0 100 101'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                      fill='#E5E7EB'
                    />
                    <path
                      d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                      fill='currentColor'
                    />
                  </svg>}
                </div>
                <div className='flex-1'>
                  Let&apos;s talk
                </div>
                <div className='flex-1' />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
